/** * * Asynchronously loads the component for
Broadband Facts
* */ import { lazyLoad } from "utils/loadable";
export const BroadbandFacts = lazyLoad(
  () => import("./index"),
  (module) => module.BroadbandFacts
);
